import React, { useMemo, useSyncExternalStore } from "react";
import { Box } from "@mui/material";
import {
  GridFooterContainer,
  GridPagination,
  type GridRowId,
} from "@mui/x-data-grid-pro";
import { BulkCheckedCount } from "./BulkCheckedCount";
import { BulkSelectionBreakdown } from "./BulkSelectionBreakdown";
import { selectCheckedItems } from "../utils/reuseSelection";
import { type CheckedIdsStore } from "../hooks/useCheckedIdsStore";
import { type BulkPropertyRow } from "../types";
import { type AcquirePolicy } from "../utils/acquirePolicy";

export interface BulkGridFooterProps {
  store: CheckedIdsStore;
  /** 依頼対象になる全行。チェックは絞り込みをまたいで維持されるため、非表示行も内訳に含める */
  rows: BulkPropertyRow[];
  /** 表示中の行ID。null は全行表示 */
  visibleRowIds: Set<GridRowId> | null;
  /** セルの可否判定と同じ確定済みの取得条件。内訳をセルの見え方と一致させる */
  policy: AcquirePolicy;
  pastDays: number;
}

/**
 * グリッドのフッター。件数・内訳とページ送りを1段にまとめ、グリッド操作中も
 * 画面下端に貼り付けて見せる（貼り付けの sx はグリッド側で指定する）
 */
export const BulkGridFooter: React.FC<BulkGridFooterProps> = ({
  store,
  rows,
  visibleRowIds,
  policy,
  pastDays,
}) => {
  const checkedAll = useSyncExternalStore(store.subscribe, store.getAll);
  // 確認ダイアログと同じ振り分けを、チェックと条件が変わるたびに回して常時表示する
  const breakdown = useMemo(
    () => selectCheckedItems(rows, checkedAll, policy, pastDays, new Date()),
    [rows, checkedAll, policy, pastDays]
  );
  return (
    <GridFooterContainer sx={{ px: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
        <BulkCheckedCount store={store} visibleRowIds={visibleRowIds} />
        <BulkSelectionBreakdown breakdown={breakdown} />
      </Box>
      <GridPagination />
    </GridFooterContainer>
  );
};
